export default "__VITE_ASSET__DsCC1aa4__"